import React from "react";
import { LoadingIndicator } from "@/components/indicators/LoadingIndicator";

/**
 * Loading fallback component for lazy-loaded window content.
 * Displays a centered loading indicator while the window content is being loaded.
 */
export function WindowLoadingFallback() {
  return (
    <div
      className="flex flex-col items-center justify-center w-full h-full min-h-[200px] bg-white dark:bg-slate-900"
      data-testid="window-loading-fallback"
    >
      <LoadingIndicator dotSize={8} animationType="wave" />
      <p className="mt-4 text-sm text-slate-500 dark:text-slate-400">
        Loading...
      </p>
    </div>
  );
}
